import { createI18n } from "vue-i18n";

let browserLang = (window.navigator.languages && window.navigator.languages[0]) ||
  window.navigator.language ||
  window.navigator.userLanguage ||
  window.navigator.browserLanguage;

// 2byteで完結しない言語コードの紐づけ
switch (browserLang) {
  // 簡体字
  case 'zh-CN':
  case 'zh-Hans':
  case 'zh-SG':
  case 'zh':
    browserLang = 'zh_Hans';
    break;
  // 繁体字
  case 'zh-Hant':
  case 'zh-MO':
  case 'zh-HK':
  case 'zh-TW':
    browserLang = 'zh_Hant';
    break;
  // ブラジルポルトガル語
  case 'pt-BR':
    browserLang = 'pt_Br';
    break;
  // メキシコスペイン語
  case 'es-MX':
    browserLang = 'es_Mx';
    break;
  default:
    break;
}

console.log("Default lang is " + browserLang)

const i18n = createI18n({
  locale: browserLang,
  fallbackLocale: "en",
  messages: {
    // 日本語
    ja: {
      app: {
        title: {
          eula:  "利用規約",
          palworldModdingGuideline: "Mod使用ガイドライン"
        },
        language: "言語",
        selectLanguage: "表示する言語を選択してください"
      },
    },
    // 英語
    en: {
      app: {
        title: {
          eula: "Terms of Service",
          palworldModdingGuideline: "Mod Usage Guidelines"
        },
        language: "Language",
        selectLanguage: "Please select a language to display"
      },
    },
    // 繁体字
    zh_Hant: {
      app: {
        title: {
          eula: "服務條款",
          palworldModdingGuideline: "Mod使用指南"
        },
        language: "語言",
        selectLanguage: "請選擇顯示語言"
      },
    },
    // 簡体字
    zh_Hans: {
      app: {
        title: {
          eula: "服务条款",
          palworldModdingGuideline: "Mod使用指南"
        },
        language: "语言",
        selectLanguage: "请选择显示语言"
      },
    },
    // フランス語
    fr: {
      app: {
        title: {
          eula: "conditions de service",
          palworldModdingGuideline: "Directives d’utilisation des mods"
        },
        language: "langue",
        selectLanguage: "Veuillez sélectionner une langue à afficher"
      },
    },
    // イタリア語
    it: {
      app: {
        title: {
          eula: "termini di servizio",
          palworldModdingGuideline: "Linee guida per l’utilizzo delle mod"
        },
        language: "lingua",
        selectLanguage: "Seleziona una lingua da visualizzare"
      },
    },
    // ドイツ語
    de: {
      app: {
        title: {
          eula: "Nutzungsbedingungen",
          palworldModdingGuideline: "Richtlinien zur Mod-Nutzung"
        },
        language: "Sprache",
        selectLanguage: "Bitte wählen Sie eine Sprache zur Anzeige aus"
      },
    },
    // スペイン語
    es: {
      app: {
        title: {
          eula: "términos de servicio",
          palworldModdingGuideline: "Guía de uso de mods"
        },
        language: "idioma",
        selectLanguage: "Por favor seleccione un idioma para mostrar"
      },
    },
    // 韓国語
    ko: {
      app: {
        title: {
          eula: "이용 약관",
          palworldModdingGuideline: "Mod 사용 가이드라인"
        },
        language: "언어",
        selectLanguage: "표시할 언어를 선택하세요."
      },
    },
    // ポルトガル語 - ブラジル
    pt_Br: {
      app: {
        title: {
          eula: "termos de serviço",
          palworldModdingGuideline: "Diretrizes de uso de mods"
        },
        language: "linguagem",
        selectLanguage: "Selecione um idioma para exibir"
      },
    },
    // ロシア語
    ru: {
      app: {
        title: {
          eula: "условия обслуживания",
          palworldModdingGuideline: "Руководство по использованию модов"
        },
        language: "язык",
        selectLanguage: "Пожалуйста, выберите язык для отображения"
      },
    },
    // インドネシア語
    id: {
      app: {
        title: {
          eula: "Syarat & Ketentuan",
          palworldModdingGuideline: "Panduan penggunaan mod"
        },
        language: "Bahasa",
        selectLanguage: "Pilih bahasa yang ingin Anda tampilkan"
      }
    },
    // タイ語
    th: {
      app: {
        title: {
          eula: "เงื่อนไขการบริการ",
          palworldModdingGuideline: "แนวทางการใช้งานม็อด"
        },
        language: "ภาษา",
        selectLanguage: "เลือกภาษาที่คุณต้องการแสดง"
      }
    },
    // メキシコスペイン語
    es_Mx: {
      app: {
        title: {
          eula: "Condiciones de servicio",
          palworldModdingGuideline: "Guía de uso de mods"
        },
        language: "idioma",
        selectLanguage: "Seleccione el idioma que desea visualizar"
      }
    },
    // トルコ語
    tr: {
      app: {
        title: {
          eula: "hizmet şartları",
          palworldModdingGuideline: "Mod kullanım yönergeleri"
        },
        language: "dil",
        selectLanguage: "Görüntülemek istediğiniz dili seçin"
      }
    },
    // ベトナム語
    vi: {
      app: {
        title: {
          eula: "điều khoản dịch vụ",
          palworldModdingGuideline: "Hướng dẫn sử dụng mod"
        },
        language: "ngôn ngữ",
        selectLanguage: "Chọn ngôn ngữ bạn muốn hiển thị"
      }
    },
    // ポーランド語
    pl: {
      app: {
        title: {
          eula: "warunki korzystania z usługi",
          palworldModdingGuideline: "Wytyczne dotyczące korzystania z modów"
        },
        language: "język",
        selectLanguage: "Wybierz język, w którym chcesz wyświetlać"
      }
    },
  },
});

export default i18n;